import { SOCIAL_ICONS, type TSocialIconType } from '@/components/icons/SocialIcons';
import type { CampaignV2ProviderType } from '@/services/endpoints/campaigns/types';

const PROVIDER_TO_SOCIAL_ICON: Record<string, TSocialIconType> = {
  WHATSAPP: SOCIAL_ICONS.WHATSAPP,
  SMS: SOCIAL_ICONS.SMS,
  EMAIL: SOCIAL_ICONS.EMAIL,
};

export const toSocialIconType = (providerType?: CampaignV2ProviderType | string): TSocialIconType | undefined => {
  if (!providerType) return undefined;
  return PROVIDER_TO_SOCIAL_ICON[providerType.toUpperCase()];
};

export const providerLabelKey = (iconType: TSocialIconType): `providerLabels.${TSocialIconType}` =>
  `providerLabels.${iconType}`;
